import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    // 首页
    path: '/',
    name: 'Home',
    component: () => import('@/views/home/Home.vue'),
  },
  {
    // 优惠码
    path: '/code',
    name: 'code',
    component: () => import('@/views/discount_code/code.vue'),
  },
  {
    // 房间查询页
    path: '/RoomList',
    name: 'RoomList',
    component: () => import('@/views/roomList/RoomList.vue'),
  },
  {
    // 订单提交页面
    path: '/BookRoom',
    name: 'BookRoom',
    component: () => import('@/views/roomList/BookRoom.vue'),
  },
  {
    // 订单列表页
    path: '/Order',
    name: 'Order',
    component: () => import('@/views/order/Order.vue'),
  },
  {
    // 订单详情页
    path: '/OrderDetail',
    name: 'OrderDetail',
    component: () => import('@/views/order/OrderDetail.vue'),
  },
  {
    // 会员页面
    path: '/Member',
    name: 'Member',
    component: () => import('../views/member/Member.vue'),
  },
  {
    // 我的页面
    path: '/Me',
    name: 'Me',
    component: () => import('../views/me/Me.vue'),
  },
  {
    // 活动页面
    path: '/Activity',
    name: 'Activity',
    component: () => import('../views/activity/Activity.vue'),
  },
  {
    // 活动详情页面
    path: '/Activity/:activityId',
    name: 'ActivityDetail',
    component: () => import('../components/activityDetail/ActivityDetail.vue'),
  },
  {
    // 优惠券列表
    path: '/CouponList',
    name: 'CouponList',
    component: () => import('../views/coupon/CouponList.vue'),
  },
  {
    // 积分竞兑换物品
    path: '/Integral',
    name: 'Integral',
    component: () => import('../views/integral/Integral.vue'),
  },
  {
    // 选择优惠券
    path: '/ChooseCoupon',
    name: 'ChooseCoupon',
    component: () => import('../views/coupon/ChooseCoupon.vue'),
  },
  {
    // 常住人
    path: '/Guest',
    name: 'Guest',
    component: () => import('../views/guest/Guest.vue'),
  },
  {
    // 意见和建议
    path: '/Feedback',
    name: 'Feedback',
    component: () => import('../views/feedback/Feedback.vue'),
  },
  {
    // 提交意见和建议
    path: '/SubmitFeedback',
    name: 'SubmitFeedback',
    component: () => import('../views/feedback/SubmitFeedback.vue'),
  },
  {
    path:'/reservation',
    name:'reservation',
    component: () => import('@/views/reservation/reservation.vue')
  },
  {
    path:'/reservationComfirm',
    name:'reservationComfirm',
    component: () => import('@/views/reservationComfirm/reservationComfirm.vue')
  },
  {
    path:'/accommodation',
    name:'accommodation',
    component: () => import('@/views/accommodation/accommodation.vue')
  },{
    path:'/location',
    name:'location',
    component: () => import('@/views/location/location.vue')
  },
  {
    path: '/contactUs',
    name: 'contactUs',
    component: () => import('@/views/contactUs/contactUs.vue')
  },
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,

  // 路由跳转时，新页面将滚动到页首位置。
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
})

export default router
